import { connect } from 'react-redux';
import InventoryAddSkuModal from '../../../components/inventory/AddSkuModal';
import {
  addInventoryItemSku,
  addInventoryPackageSku
} from '../../../redux/Inventory/sagas/routines';
import {
  getIsSaving as getIsSavingItem,
  getIsSaved as getIsSavedItem
} from '../../../redux/Inventory/selectors/item/skus';
import {
  getIsSaving as getIsSavingPackage,
  getIsSaved as getIsSavedPackage
} from '../../../redux/Inventory/selectors/package/skus';
import { fetchInventoryItemOptions } from '../../../redux/Inventory/sagas/components/item-form/routines';
import { fetchInventoryPackageOptions } from '../../../redux/Inventory/sagas/options/routines';
import {
  getItemOptions,
  getIsFetchingItemOptions,
  getIsFetchedItemOptions
} from '../../../redux/Inventory/selectors/components/item-form';
import {
  getPackageOptions,
  getIsFetching as getIsFetchingPackageOptions,
  getIsFetched as getIsFetchedPackageOptions
} from '../../../redux/Inventory/selectors/options/package';
import { ItemType } from '../../../constants/inventory/InventoryTypes';

function mapStateToProps(state, props) {
  return {
    ...props,
    itemOptions: getItemOptions(state),
    packageOptions: getPackageOptions(state),
    isSavingItem: getIsSavingItem(state),
    isSavedItem: getIsSavedItem(state),
    isSavingPackage: getIsSavingPackage(state),
    isSavedPackage: getIsSavedPackage(state),
    isFetchingItemOptions: getIsFetchingItemOptions(state),
    isItemOptionsFetched: getIsFetchedItemOptions(state),
    isFetchingPackageOptions: getIsFetchingPackageOptions(state),
    isPackageOptionsFetched: getIsFetchedPackageOptions(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchInventoryItemOptions());
      dispatch(fetchInventoryPackageOptions());
    },
    onSubmit: ({ itemId, sku, type }) => {
      if (type === ItemType) dispatch(addInventoryItemSku({ id: itemId, sku }));
      else dispatch(addInventoryPackageSku({ id: itemId, sku }));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryAddSkuModal);
